/* eslint-disable no-unused-vars */
import { Suspense, useContext } from 'react';

// import Loaders from 'components/atoms/Loaders';
import SideNav from 'components/organisms/SideNav';
import TopBar from 'common/TopBar';
import Loaders from 'components/atoms/Loaders';
import GoogleMap from 'components/organisms/Map';
import { AuthContext } from 'context/authContext';
import { FiltersContext } from 'context/filtersContext';
import { Content, ContentWrap, FlexContainer, Map } from './PageTemplate.styles';

function PageTemplate({ title, showTemplate, children, topBar, googleMap, showMap }) {
  const { province } = useContext(AuthContext);
  const { overlay } = useContext(FiltersContext);
  return showTemplate ? (
    <Content>
      {topBar && <TopBar title={title} />}
      <FlexContainer>
        <SideNav />
        <Suspense fallback={<Loaders pageLoader />}>
          <ContentWrap>
            {overlay && <span className="content-overlay" />}
            {children}
          </ContentWrap>
        </Suspense>
      </FlexContainer>
      {showMap && (
        <Map>
          <GoogleMap address="" province={province} />
        </Map>
      )}
    </Content>
  ) : (
    children
  );
}

export default PageTemplate;
